import { Select } from '@bancobarigui/barihaus';
import { OPCOES_PRECISAO, OPCOES_FUNDAMENTACAO } from '../utils';
import * as styles from '../styles';
import { ReviewFieldWrapper } from '../../../../ReviewFieldWrapper';

interface ClassificacaoSectionProps {
  grauPrecisao: string;
  grauFundamentacao: string;
  onUpdateClassificacao?: (campo: 'grauPrecisao' | 'grauFundamentacao', valor: string) => void;
  disabled?: boolean;
}

export function ClassificacaoSection({
  grauPrecisao,
  grauFundamentacao,
  onUpdateClassificacao,
  disabled,
}: ClassificacaoSectionProps) {
  return (

      <div style={styles.classificacaoGridStyle}>
      <div>
        <label style={styles.labelStyle}>Grau de Precisão</label>
        <ReviewFieldWrapper
          fieldPath="amostras.grauPrecisao"
          fieldLabel="Grau de Precisão"
          stepName="Metodologia"
        >
          <Select
            value={grauPrecisao}
            onChange={(valor) => onUpdateClassificacao?.('grauPrecisao', valor as string)}
            style={{ width: '100%' }}
            disabled={disabled ?? false}
            options={OPCOES_PRECISAO.map((opcao) => ({
              label: opcao,
              value: opcao,
              disabled: false,
            }))}
          />
        </ReviewFieldWrapper>
      </div>

      <div>
        <label style={styles.labelStyle}>Grau de Fundamentação</label>
        <ReviewFieldWrapper
          fieldPath="amostras.grauFundamentacao"
          fieldLabel="Grau de Fundamentação"
          stepName="Metodologia"
        >
          <Select
            value={grauFundamentacao}
            onChange={(valor) => onUpdateClassificacao?.('grauFundamentacao', valor as string)}
            style={{ width: '100%' }}
            disabled={disabled ?? false}
            options={OPCOES_FUNDAMENTACAO.map((opcao) => ({
              label: opcao,
              value: opcao,
              disabled: false,
            }))}
          />
        </ReviewFieldWrapper>
      </div>
      </div>
  );
}
